export const EVENT_UPDATE_NOTIFICATION_MODE = {
    NONE: 'NONE',
    BADGE: 'BADGE',
    FULL_ROW: 'FULL_ROW',
} as const;
